import { TabBar } from "components/Tabbar/Tabbar";
import { useEffect, useState } from "react";

//import { getCustomerForm, sendCustomer } from "./api";
import { PersonLegalForm } from "pages/OfficeAutomation/BaseInformation/PeoplePage/components/PersonLegalList/component/PersonLegalForm/PersonLegalForm";
import { PersonRealForm } from "pages/OfficeAutomation/BaseInformation/PeoplePage/components/PersonRealList/components/PersonRealForm/PersonRealForm";
import {  getPerson } from "pages/OfficeAutomation/BaseInformation/PeoplePage/components/api/api";
import { Loading } from "components/Loading/loading";

interface Form {
  setShowPersonForm: (e) => void;
  setNewPerson: (e) => void;
  setResetForm: (e) => void;
  mode: any;
  PersonId: any;

}
export const PersonFormInTab = ({ setShowPersonForm,PersonId, mode, setNewPerson ,setResetForm  }: Form) => {

  const [curentTab, setCurentTab] = useState<any>("PersonRealForm")
  const [loading, setLoading] = useState<boolean>(false);
  const [personResponse, setPersonResponse] = useState<Response | any>();



  let content = [
    { title: "PersonRealForm", body: (
        <PersonRealForm
        showSaveClose={false}
        mode={mode}
        idPersonReal={PersonId}
        ButtonInTop={true}
        handleCancelForm={(e)=>{setShowPersonForm(false)}}
        handleAddPerson={(e)=>{ setNewPerson(e.Data);setResetForm(true);setShowPersonForm(false)}}
     />
), },
    { title: "PersonLegalForm", body: (
        <PersonLegalForm
        showSaveClose={false}
        mode={mode}
        idPerson={PersonId}
        ButtonInTop={true}
        handleCancelForm={()=>{setShowPersonForm(false)}}
        handleAddPerson={(e)=>{ setNewPerson(e.Data);setResetForm(true);setShowPersonForm(false)}}
   />
), },
  ];
    async function getDataAsync(Id) {
      setLoading(false)
      
      try {
        const response = await getPerson(Id);
        setPersonResponse(response);  
       } catch (error) {
         
       }

       setLoading(true)
    }


  const tabChangeHandle = (tab) => {
    setCurentTab(tab)
  } 


   useEffect(() => {
      if(mode=="view")
        getDataAsync(PersonId)
    }, [PersonId , mode]);

  return (
    <>
    {mode!="view" ?
    <TabBar  tabChange={tabChangeHandle} content={content} curentTab={curentTab} defaultTab={"PersonRealForm"} />
   :

   <>
      {loading?
      <>
        {personResponse?.data?.Data?.PersonRealDTO!=null?
                <PersonRealForm
                person={personResponse}
                showSaveClose={false}
                mode={mode}
                idPersonReal={PersonId}
                ButtonInTop={true}
                handleCancelForm={(e)=>{setShowPersonForm(false)}}
                handleAddPerson={(e)=>{ setNewPerson(e.Data);setResetForm(true);setShowPersonForm(false)}}
             />
          :
          <PersonLegalForm
          showSaveClose={false}
          mode={mode}
          person={personResponse}

          idPerson={PersonId}
          ButtonInTop={true}
          handleCancelForm={()=>{setShowPersonForm(false)}}
          handleAddPerson={(e)=>{ setNewPerson(e.Data);setResetForm(true);setShowPersonForm(false)}}
     />
      }

      </>
    
    :<Loading/>
    }

   </> 
  
  }
    </>
  )
}